export const ALERTS_POSITION = "bottom-center"
export const ALERTS_POSITION_SELFIE = "top-center"

export const ALERTS_STYLES = {
  duration: 3000,
  style: {
    fontSize: '0.8rem',
    borderRadius: '5px'
  },
  success: {
    style: {
      background: '#213B30',
      color: '#fff',
    }
  },
  error: {
    style: {
      background: '#FEE1DA',
      color: '#2F2E33',
    }
  },
}

export const ALERTS_STYLES_SELFIE = {
  duration: 3000,
  style: {
    fontSize: '0.8rem',
    borderRadius: '5px'
  },
  success: {
    style: {
      background: '#213B30',
      color: '#fff',
    }
  },
  error: {
    style: {
      background: '#FEE1DA',
      color: '#2F2E33',
    }
  },
}

